import { IPromise } from 'angular';
import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { requestFailed } from '../../app/actions/RequestFailedAction';
import { ServiceLocator } from '../../app/ServiceLocator';
import { Messages } from '../../codegen/Localize';
import { FlowListItemInfo } from '../../ts/models/FlowInfo';
import { Set } from '../../ts/models/Set';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { RunFlowAction } from '../../ts/services/RunFlowAction';
import { RunFlowReduxAction } from '../actions/RunFlowReduxAction';
import { getFlowListItemInfos } from '../FlowsSagaHelpers';
import { FlowRunEvent } from '../utils/FlowEvents';

export function openRunFlowsDialog(flowListItemInfos: FlowListItemInfo[]): IPromise<IResult> {
  const runFlowAction = ServiceLocator.get<RunFlowAction>('RunFlowAction');
  const context = ServiceLocator.getAngularActionContext();
  const flowSet = Set.fromIdItemArray(flowListItemInfos);
  return runFlowAction.showRunFlowDialog(flowSet, context);
}

export function broadcastFlowRunEvent() {
  ServiceLocator.getAngularActionContext().scope.$broadcast(FlowRunEvent);
}

export function* handleRunFlow(action: RunFlowReduxAction): SagaIterator {
  try {
    if (action.selectedContent && action.selectedContent[0].contentType === 'flow') {
      const flowListItemInfos = yield call(getFlowListItemInfos, action.selectedContent);
      yield call(openRunFlowsDialog, flowListItemInfos);
      yield call(broadcastFlowRunEvent);
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

